import {AVAILABLE_LOCALES, AVAILABLE_LOCALE_NAMES} from '@/services/locale/constants';

import {LocaleItem} from './types';

export const SEARCHABLE_ITEMS: LocaleItem[] = AVAILABLE_LOCALES.map(locale => ({
    id: locale,
    name: AVAILABLE_LOCALE_NAMES[locale]
}));
